import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    salesChannelId: 'fe2d5963-cd83-49bc-a08e-71be666c92ed',
    countryCodes: ['DK'],
    locale: 'da-DK',
});
